import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_dialog_component = _resolveComponent("dialog-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.activityData)
      ? (_openBlock(), _createBlock(_component_router_view, {
          key: 0,
          class: _normalizeClass([_ctx.dialogData && 'filter-show'])
        }, null, 8, ["class"]))
      : _createCommentVNode("", true),
    (_ctx.dialogData)
      ? (_openBlock(), _createBlock(_component_dialog_component, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}